<script setup lang="ts">
import FormTextField from "@/components/Common/FormTextField.vue"; 
import FormRow from "@/components/Common/FormRow.vue";
import accountType from "@/types/account";
import { computed } from "vue";
import i18n from '@/lang/i18n';

const emits = defineEmits(['update:modelValue'])
const props = defineProps<{
  account: accountType | null;
  modelValue: string;
  errors: {[key: string]: string[]};
}>();

const modelValue = computed({
  get() {
    return props.modelValue;
  },
  set(value) {
    emits("update:modelValue", value);
  },
})
</script>
<template>
  <div class="pt-3">
    <FormRow
      :title="i18n.global.t('pages.tenkoAssociation.editModal.operationOffice')"
      rowContentClass="my-auto"
    >
      <div>
        {{ props.account?.officeable.operation_office_name }}
      </div>
    </FormRow>
    <FormRow
      :title="i18n.global.t('pages.tenkoAssociation.editModal.driverId')"
      rowContentClass="my-auto"
    >
      <div>
        {{ props.account?.driver_id }}
      </div>
    </FormRow>
    <FormTextField
      :title="i18n.global.t('pages.tenkoAssociation.editModal.employeeCode')"
      v-model="modelValue"
      :error="props.errors.employee_cd"
      :required="true"
      rowContentClass="my-auto"
    >
    </FormTextField>
  </div>
</template>
